export const HAND = 'ica-hand';
export const RUBRIK_BLACK = 'ica-rubrik-black';
export const TEXT_BLACK = 'ica-text-black';
export const TEXT_REGULAR = 'ica-text-regular';
export const TEXT_LIGHT = 'ica-text-light';
export const HELVETICA = '"Helvetica Neue", Helvetica, Roboto, Arial, sans-serif';
